"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/PostRegistrationForm.scss");
var PostRegistrationForm = /** @class */ (function (_super) {
    __extends(PostRegistrationForm, _super);
    function PostRegistrationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (event) {
            event.preventDefault();
            if (!_this.state.termsConditions) {
                return;
            }
            //I know this looks stupid but this is so that the tokens placed here by the env vars are replaced correctly in the release pipeline
            var paymentPageUrl = process.env.REACT_APP_PAYMENTPAGEURL;
            var regionName = process.env.REACT_APP_REGIONNAME;
            var completeUrl = paymentPageUrl + "|" + regionName;
            if (_this.state.annual) {
                window.location.href = completeUrl.replace('|', '') + "-annual";
            }
            else if (_this.state.monthly) {
                window.location.href = completeUrl.replace('|', '') + "-monthly";
            }
        };
        _this.radioOnChange = function (selection) {
            _this.setState({
                monthly: selection === 0,
                annual: selection === 1
            });
        };
        _this.state = {
            monthly: false,
            annual: false,
            termsConditions: false
        };
        _this.monthlyInputRef = React.createRef();
        _this.annualInputRef = React.createRef();
        _this.termsConditionsInputRef = React.createRef();
        return _this;
    }
    PostRegistrationForm.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement(reactstrap_1.Form, { onSubmit: this.handleSubmit },
            React.createElement(reactstrap_1.FormGroup, null,
                React.createElement(reactstrap_1.Label, { for: "subscription-type" }, (_a = this.props.resources) === null || _a === void 0 ? void 0 : _a.Registration_LicenceSelectSubsctiption),
                React.createElement("div", null,
                    React.createElement(reactstrap_1.CustomInput, { className: "custom-radio-inverted", checked: this.state.monthly, onChange: function () { return _this.radioOnChange(0); }, type: "radio", name: "subscription-type", id: "subscription-type-monthly", label: this.props.resources.Registration_LicenceSelectMonthlySubscription }),
                    React.createElement(reactstrap_1.CustomInput, { className: "custom-radio-inverted", checked: this.state.annual, onChange: function () { return _this.radioOnChange(1); }, type: "radio", name: "subscription-type", id: "subscription-type-annual", label: this.props.resources.Registration_LicenceSelectAnnualSubscription }))),
            React.createElement(reactstrap_1.FormGroup, { style: { display: 'flex' } },
                React.createElement(reactstrap_1.Label, { for: "terms-conditions-checkbox" },
                    this.props.resources.Registration_LicenceReadAcceptTerms,
                    "\u00A0",
                    React.createElement("a", { style: { color: 'white', textDecoration: 'underline' }, href: this.props.resources.Registration_TermsConditionsUrl, target: "_blank" }, this.props.resources.Registration_TermsConditionsText)),
                React.createElement(reactstrap_1.CustomInput, { checked: this.state.termsConditions, onChange: function () { return _this.setState({ termsConditions: !_this.state.termsConditions }); }, type: "checkbox", name: "terms-conditions-checkbox", id: "terms-conditions-checkbox", className: "custom-checkbox-inverted ml-2", inline: true })),
            React.createElement(reactstrap_1.Button, { outline: true, color: "light", className: "" + ((this.state.annual || this.state.monthly) && this.state.termsConditions ? "" : "disabled") }, this.props.resources.Registration_LicenceGoToPayment)));
    };
    return PostRegistrationForm;
}(React.Component));
exports.PostRegistrationForm = PostRegistrationForm;
//# sourceMappingURL=PostRegistrationForm.js.map